import { mapToCanActivate, Routes } from '@angular/router';
import { InventoryCampaignDetails } from './components/inventory-campaign-details/inventory-campaign-details';
import { VehicleCampaignDetails } from './components/vehicle-campaign-details/vehicle-campaign-details';
import { CampaignInventoryInternal } from './components/campaign-inventory-internal/campaign-inventory-internal/campaign-inventory-internal';
import { CampaignInventoryInternalSearch } from './components/campaign_inventory_internal_search/campaign-inventory-internal-search/campaign-inventory-internal-search';
import { CampaignInventoryInternalNational } from './components/campaign-inventory-internal-national/campaign-inventory-internal-national';
import { CampaignInventoryInternalRegion } from './components/campaign-inventory-internal-region/campaign-inventory-internal-region';
import { CampaignInventoryInternalMarket } from './components/campaign-inventory-internal-market/campaign-inventory-internal-market';
export const routes: Routes = [
  { path: '', component: InventoryCampaignDetails },
  { path: 'icd', component: InventoryCampaignDetails }, // OAuth redirect path
  { path: 'InventoryCampaignDetails', component: InventoryCampaignDetails },
  { path: 'vcd', component: VehicleCampaignDetails },
  {
    path: 'campaign_inventory_internal',
    component: CampaignInventoryInternalNational,
  },
  // {  path: "campaign_inventory_internal_search", component: CampaignInventoryInternalSearch},
  {
    path: 'campaign_inventory_internal_national',
    component: CampaignInventoryInternalNational,
  },
  {
    path: 'campaign_inventory_internal_region',
    component: CampaignInventoryInternalRegion,
  },
  {
    path: 'campaign_inventory_internal_market',
    component: CampaignInventoryInternalMarket,
  },
  {
    path: '**',
    redirectTo: 'InventoryCampaignDetails',
    pathMatch: 'full',
  },
];
